import { defineComponent as _defineComponent } from 'vue'
import logo_dark from '../assets/images/logo/logo_frk.svg';
import logo_light from '../assets/images/logo/logo_frk_light.svg';

export default /*#__PURE__*/_defineComponent({
  __name: 'FrkLogo',
  setup(__props) {


return { __sfc: true,logo_dark, logo_light }
}

})